import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { formatApiError } from "../lib/api";
import Header from "../components/Header";
import Logo from "../components/Logo";
import { ArrowRight } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      const user = await login(email, password);
      const target = loc.state?.from ||
        (user.role === "super_admin" ? "/super-admin" :
         user.role === "cafe_owner" ? "/dashboard" : "/");
      nav(target);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen text-[#F5F0EB]">
      <Header />
      <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16">
        <div className="w-full max-w-md">
          <div className="flex justify-center mb-8"><Logo size={64} variant="mark" /></div>
          <div className="overline mb-6 text-center">Espace privé · CAFÉ-SPOT</div>
          <h1 className="font-serif text-5xl font-light mb-3 text-center">{t("auth.welcomeBack")}</h1>
          <p className="text-[#A8A39D] text-sm mb-10 text-center">{t("auth.noAccount")} <Link to="/register" className="text-[#C5A059] hover:underline">{t("auth.signUp")}</Link></p>

          <form onSubmit={submit} className="space-y-6">
            <div>
              <label className="overline text-xs">{t("auth.email")}</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="luxe-input mt-2" placeholder="vous@exemple.com" />
            </div>
            <div>
              <label className="overline text-xs">{t("auth.password")}</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="luxe-input mt-2" placeholder="••••••••" />
            </div>
            {err && <div data-testid="login-error" className="text-red-400 text-sm">{err}</div>}
            <button data-testid="login-submit" type="submit" disabled={loading} className="btn-gold w-full mt-8">
              {loading ? "..." : t("auth.submit")} <ArrowRight size={14} />
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/forgot-password" data-testid="forgot-link" className="text-xs tracking-widest uppercase text-[#A8A39D] hover:text-[#C5A059]">Mot de passe oublié ?</Link>
          </div>

          <div className="mt-10 text-xs text-[#A8A39D] tracking-wider">
            DEMO Super Admin · owner@luxecoffee.com / SuperAdmin2026!
          </div>
        </div>
      </div>
    </div>
  );
}
